import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { MenuItem, DropDownMenu } from 'material-ui';
import { updateUMProps, getUsersByFilter } from '../../../stores/settings/userManagement/actions';
import AddNewUser from './newUser/container';

const Header = props => {
  const {
    viewBy,
    updateProp,
    getUsers,
    companyType,
    isSingleLoc,
    isAccom,
  } = props;

  const views = (companyType === 'Contractor' || isSingleLoc) ? [{ label: 'Team', value: 'team' }, { label: 'User', value: 'user' }]
    : [{ label: isAccom ? 'Property' : 'Location', value: 'location' }, { label: 'Team', value: 'team' }, { label: 'User', value: 'user' }];

  return (
    <div style={{ marginTop: '12px', width: '100%' }}>
      <div style={{ height: '55px', width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', padding: '0 2%' }}>
          <div style={{ fontSize: '15px' }}>Viewing By:</div>
          <div style={{ marginLeft: '-5px' }}>
            <DropDownMenu value={viewBy} autoWidth underlineStyle={{ borderTopColor: '#00bcd4' }} style={{ marginTop: '4px' }}>
              {
                views.map((view, i) => (
                  <MenuItem
                    key={i}
                    primaryText={view.label}
                    value={view.value}
                    onTouchTap={() => {
                      updateProp({ viewBy: view.value });
                      getUsers(view.value);
                    }}
                  />
                ))
              }
            </DropDownMenu>
          </div>
        </div>
      </div>
      <AddNewUser />
    </div>
  );
};

Header.propTypes = {
  viewBy: PropTypes.string,
  updateProp: PropTypes.func,
  getUsers: PropTypes.func,
  companyType: PropTypes.string,
  isSingleLoc: PropTypes.bool,
  triggerNoAccessWarning: PropTypes.func,
  isAccom: PropTypes.bool,
};

const mapDispatchToProps = dispatch => ({
  triggerNoAccessWarning: payload => dispatch({ type: 'GLOBAL_ERROR_TRIGGERED', payload }),
  updateProp: (...args) => dispatch(updateUMProps(...args)),
  getUsers: viewBy => dispatch(getUsersByFilter(viewBy)),
});

const mapStateToProps = ({ userManagement, user }) => ({
  viewBy: userManagement.get('viewBy'),
  companyType: user.getIn(['user', 'type']),
  isSingleLoc: user.getIn(['company', 'oneOrMultiProperties']) === 'one-prop',
  isAccom: user.getIn(['company', 'productType']) === 'Accommodation',
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/app/components/settings/userManagement/header.jsx